import { t, translate } from "../I18n";
export function getDepositIcon(depositType) {
    switch (depositType) {
        case "SingleUsePlasticBottle":
            return {
                type: "PLDeposit50Icon",
                deposit: "SingleUsePlasticBottle",
                description: translate(t.order.deposit.singleUsePlasticBottle),
            };
        case "MetalCan":
            return {
                type: "PLDeposit50Icon",
                deposit: "MetalCan",
                description: translate(t.order.deposit.metalCan),
            };
        case "MultiUseGlassBottle":
            return {
                type: "PLDeposit100Icon",
                deposit: "MultiUseGlassBottle",
                description: translate(t.order.deposit.multiUseGlassBottle),
            };
    }
}
/**
 * Generic helper to extract deposit data from extraFees.
 * Returns null if multiple different deposits are found for the same item.
 *
 * @param extraFees - Array of extra fees from catalogue
 * @param matchPredicate - Function that determines if a requirement matches the item
 * @returns DepositIcon if exactly one deposit type is found, null otherwise
 */
export function extractDepositFromExtraFees(extraFees, matchPredicate) {
    let foundDeposit = null;
    for (const extraFee of extraFees) {
        if (extraFee.tag !== "PackagingFee" || extraFee.deposit === null) {
            continue;
        }
        for (const requirement of extraFee.requirements) {
            if (matchPredicate(requirement)) {
                // If we already found a deposit with a different type, return null
                if (foundDeposit !== null &&
                    foundDeposit.deposit !== extraFee.deposit) {
                    return null;
                }
                foundDeposit = getDepositIcon(extraFee.deposit);
            }
        }
    }
    return foundDeposit;
}
